module.controller('giftPlastic', ['$scope', '$state', 'baseURI', '$http', 'Transform', '$window', '$timeout', '$stateParams', 'SECURITY_QUESTIONS', 'giftAuthService', 'trustPilotService', function($scope, $state, baseURI, $http, Transform, $window, $timeout, $stateParams, SECURITY_QUESTIONS, giftAuthService, trustPilotService){
  var giftPlasticUrl = baseURI + 'gift-card/collect/plastic';
  $scope.passwordInputType = 'password';
  $scope.showValidateEmail = false;
  $scope.showUpdatedEmail = false;
  $scope.loadingEmailVerification = false;
  $scope.attemptToChangeEmail = false;
  $scope.canChangeEmail = false;

  //set the email
  var email = $stateParams.email;
  $scope.formData.email = email;

  // set parent view form class
  $scope.parent.formType = 'floatingForm-form';

  // submission for kyc
  $scope.attemptSubmission = function(joinForm){
    if(joinForm.$valid){
      verifyEmail();
    } else {
      $scope.submitted = true;
    }
  };

  // CH selects to update email that is provided from url params
  $scope.changeEmail =function(){
    $scope.attemptToChangeEmail = true;
    verifyEmail();
  };


  // final submission
  var submitRegistration = function(){
    $scope.parent.overlayLoading = true;
    var formData = $scope.formData;
    var request = {
      FirstName: formData.firstName,
      LastName: formData.lastName,
      StreetAddress: formData.address,
      SuiteNumber: formData.address2 || '',
      City: formData.city,
      State: formData.state,
      Zipcode: formData.zip,
      Username: formData.email,
      Email: formData.email,
      NewEmail: $scope.formData.updatedEmail || '',
      Password: formData.password,
      Phone: formData.phone
    };

    $http({
      method: 'POST',
      url: giftPlasticUrl,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      data: Transform.encode(request)
    }).then(function (resp){
      var data = resp.data;

      $scope.parent.overlayLoading = false;
      data.email = request.Email;

      if($scope.formData.textAlerts){
        // set txt alerts for primary
        // if sub, set the subcard username
        data.textAlerts = {
          phoneNumber: $scope.formData.phone,
          subcard: null
        };
      } else {
        data.textAlerts = false;
      }

      giftAuthService.handleAuth(data, $scope.formData.VerificationCode);
      trustPilotService.sendTpInvitation(request.Email, request.FirstName, 'giftPlastic');

    }).catch(function(err){
      $scope.parent.overlayLoading = false;
      $scope.alertError.show = true;
      $scope.alertError.message = 'Oops, we are unable to register your card at this time.';
    });
  };


  // Verification email process
  var verifyEmail = function(){
    createVerificationCode();
  };

  // Make request for validation Code
  var createVerificationCode = function(){
    $scope.loading = true;
    var reqData = {
      Email: $scope.formData.updatedEmail || $scope.formData.email,
      _key: $scope.brand.api_key
    };

    $http({
      url: baseURI + 'email/verification',
      method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
      data: Transform.encode(reqData)
    }).then(function (resp){
      var data = resp.data;

      $scope.loading = false;
      if(data.Success){
        // Open the modal
        $scope.showValidateEmail = true;
        startCountDown();
      } else {
        $scope.alertError.show = true;
        $scope.alertError.message = 'Sorry, we were unable to verify your email address at this time. Please try again later.';
      }
    }).catch(function(error){
      $scope.loading = false;
      $scope.alertError.show = true;
      $scope.alertError.message = 'Sorry, we were unable to verify your email address at this time. Please try again later.';
    });
  };

  // User is manually submitting code
  $scope.submitCode = function(){
    if(!$scope.formData.VerificationCode){
      $scope.attemptedVerify = true;
      $scope.invalidVerify = false;
    } else {
      $scope.loading = true;
      $scope.attemptedVerify = false;
      var verifiedReq = {
        Email: $scope.formData.updatedEmail || $scope.formData.email,
        VerificationCode: $scope.formData.VerificationCode
      };

      $http({
        url: baseURI + 'email/verification',
        method: 'PUT',
        headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'},
        data: Transform.encode(verifiedReq)
      }).then(function(resp){
        var data = resp.data;

        $scope.loading = false;
        $scope.invalidVerify = !data.Success;
        if(data.Success){
          $scope.stopTimeout();
          successVerfication();
        }
      }).catch(function(error){
        $scope.invalidVerify = true;
        $scope.loading = false;
      });
    }
  };

  // User clicks on resend email link
  $scope.reSend = function(){
    $scope.stopTimeout();
    $scope.loadingEmailVerification = true;
    createVerificationCode();
  };

  // Close the modal
  $scope.close = function(){
    $scope.stopTimeout();
    $scope.showValidateEmail = false;
  };

  // User has successfully completed email verification
  var successVerfication = function(){
    $scope.$parent.verifiedEmail = true;
    $scope.loadingEmailVerification = true;
    $scope.showValidateEmail = false;

    if($scope.attemptToChangeEmail){
      $scope.canChangeEmail = true;
      $scope.attemptToChangeEmail = false;
    } else {
      submitRegistration();
    }
  };

  var startCountDown = function() {
    $scope.counter = 1200;

    $scope.onTimeout = function(){
      $scope.counter--;
      if($scope.counter > 1){
        myTimeout = $timeout($scope.onTimeout, 1000);
      } else {
        $scope.stopTimeout();
        $scope.showValidateEmail = false;
      }
    };

    // Create the promise
    var myTimeout = $timeout($scope.onTimeout, 1000);

    // Cancel the promise
    $scope.stopTimeout = function() {
      $timeout.cancel(myTimeout);
    };

  };


}]);
